import React from 'react';
import Link from 'next/link';
import { ArrowUpRight } from 'lucide-react';

/**
 * Graha Prime style button — hover үед өнгө slide хийдэг
 */
export default function Button({
    children,
    href,
    onClick,
    variant = 'primary',
    size = 'md',
    icon = true,
    iconComponent,
    type = 'button',
    disabled,
    target,
    rel,
    className = '',
    ...rest
}) {
    const variants = {
        primary:
            'group bg-brand-yellow text-brand-dark hover:bg-brand-dark hover:text-brand-yellow border-2 border-brand-yellow hover:border-brand-dark',
        dark:
            'group bg-brand-dark text-white hover:bg-brand-yellow hover:text-brand-dark border-2 border-brand-dark hover:border-brand-yellow',
        light:
            'group bg-white text-brand-dark hover:bg-brand-dark hover:text-white border-2 border-white hover:border-brand-dark',
        'outline-yellow':
            'group border-2 border-brand-yellow text-brand-yellow hover:bg-brand-yellow hover:text-brand-dark',
        'outline-white':
            'group border-2 border-white text-white hover:bg-white hover:text-brand-dark',
        'outline-dark':
            'group border-2 border-brand-dark text-brand-dark hover:bg-brand-dark hover:text-white',
    };

    const sizes = {
        sm: 'text-xs px-5 py-2.5',
        md: 'text-sm px-7 py-3.5',
        lg: 'text-base px-9 py-4',
    };

    const Icon = iconComponent || ArrowUpRight;

    const classes = `inline-flex items-center justify-center gap-3 font-heading uppercase font-semibold tracking-wider transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed ${variants[variant]} ${sizes[size]} ${className}`;

    const inner = (
        <>
            <span>{children}</span>
            {icon && (
                <Icon
                    size={size === 'lg' ? 18 : 16}
                    className="transition-transform duration-300 group-hover:rotate-45"
                    strokeWidth={2}
                />
            )}
        </>
    );

    if (href) {
        const isExternal = /^https?:\/\//.test(href);
        if (isExternal) {
            return (
                <a
                    href={href}
                    target={target || '_blank'}
                    rel={rel || 'noopener noreferrer'}
                    className={classes}
                    {...rest}
                >
                    {inner}
                </a>
            );
        }
        return (
            <Link href={href} className={classes} {...rest}>
                {inner}
            </Link>
        );
    }

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={classes}
            {...rest}
        >
            {inner}
        </button>
    );
}
